// Section 17: Minimum floor then priority (the default). Everyone gets a floor (default 0.5 of
// need), then the remainder goes by priority order.
import { applyPins, equalFill, flattenRanked, priorityFill } from '../../core/allocation';
import { defineRationPolicy } from '../../core/registry';
import type { Config } from '../../config';

export function floorPriority(_config: Config) {
  return defineRationPolicy({
    id: 'floor-priority',
    label: 'Minimum floor then priority',
    section: 'S17',
    allocate(_ctx, input) {
      const order = flattenRanked(input.ranked);
      const fill = applyPins(order, input.demand, input.available, input.pinned);
      const free = order.filter((id) => input.pinned[id] === undefined);
      equalFill(free, input.demand, fill, input.floor);
      priorityFill(
        input.ranked.map((g) => g.filter((id) => input.pinned[id] === undefined)),
        input.demand,
        fill,
      );
      return { shares: fill.shares, order };
    },
  });
}
